var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 14.35C10.27 14.35 9.21 13.95 8.41 13.16L7.87 12.62C7.48 12.23 7.48 11.6 7.87 11.21C8.26 10.82 8.89 10.82 9.28 11.21L9.81 11.75C10.64 12.57 11.98 12.57 12.81 11.75L17.13 7.47003C17.68 6.92003 17.99 6.19003 17.99 5.41003C17.99 4.63003 17.69 3.90003 17.13 3.35003C16.02 2.25003 14.21 2.25003 13.1 3.35003L11.48 4.96003C11.09 5.35003 10.46 5.35003 10.07 4.96003C9.68 4.57003 9.68 3.94003 10.07 3.55003L11.69 1.94003C13.57 0.0600293 16.65 0.0600293 18.54 1.94003C19.47 2.87003 19.99 4.10003 19.99 5.42003C19.99 6.74003 19.48 7.98003 18.54 8.90003L14.22 13.18C13.42 13.98 12.37 14.37 11.31 14.37L11.32 14.35ZM8.3 19.1L9.92 17.49C10.31 17.1 10.31 16.47 9.92 16.08C9.53 15.69 8.9 15.69 8.51 16.08L6.89 17.69C5.78 18.8 3.97 18.8 2.86 17.69C2.31 17.14 2 16.41 2 15.63C2 14.85 2.3 14.12 2.86 13.57L7.18 9.29003C8.01 8.47003 9.35 8.47003 10.18 9.29003L10.71 9.82003C11.1 10.21 11.73 10.21 12.12 9.82003C12.51 9.43003 12.51 8.80003 12.12 8.41003L11.58 7.87003C9.98 6.28003 7.37 6.28003 5.76 7.87003L1.45 12.13C0.52 13.06 0 14.29 0 15.61C0 16.93 0.51 18.17 1.45 19.09C2.39 20.03 3.63 20.49 4.87 20.49C6.11 20.49 7.35 20.02 8.3 19.08V19.1Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6e7bb5d8a59107bffbdfa9116554428f.svg";
export { ForwardRef as ReactComponent };